// extracted by mini-css-extract-plugin
export default {"wrapper":"CheckBox_wrapper__srK0E","disabled":"CheckBox_disabled__w3HBD"};